import React, { useState, useEffect } from 'react';
import { useOfflineStatus } from '../../utils/offline';

/**
 * OfflineIndicator Component — YouTube-style bottom bar
 * Shows a thin black bar at the bottom with "You are offline" when disconnected.
 * Shows a brief "Back online" confirmation when connection is restored.
 */
const OfflineIndicator = () => {
  const { isOnline } = useOfflineStatus();
  const [showBackOnline, setShowBackOnline] = useState(false);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      setWasOffline(true);
      setShowBackOnline(false);
    } else if (wasOffline) {
      // Just came back online
      setShowBackOnline(true);
      const timer = setTimeout(() => {
        setShowBackOnline(false);
        setWasOffline(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isOnline]);

  if (isOnline && !showBackOnline) return null;

  return (
    <>
      <style>{`
        @keyframes offline-slide-up {
          from { transform: translateY(100%); opacity: 0; }
          to   { transform: translateY(0);    opacity: 1; }
        }
        @keyframes offline-slide-down {
          from { transform: translateY(0);    opacity: 1; }
          to   { transform: translateY(100%); opacity: 0; }
        }
        .offline-bar-enter {
          animation: offline-slide-up 0.3s ease-out forwards;
        }
        .offline-bar-exit {
          animation: offline-slide-down 0.3s ease-in forwards;
        }
      `}</style>

      <div
        className={`fixed bottom-0 left-0 right-0 z-[9999] flex items-center justify-center ${
          showBackOnline ? 'offline-bar-exit' : 'offline-bar-enter'
        }`}
        style={{
          backgroundColor: showBackOnline ? '#1a1a1a' : '#0f0f0f',
          height: '36px',
          pointerEvents: 'none',
        }}
      >
        {showBackOnline ? (
          <span
            style={{
              color: '#ffffff',
              fontSize: '13px',
              fontWeight: 600,
              letterSpacing: '0.01em',
            }}
          >
            Back online
          </span>
        ) : (
          <span
            style={{
              color: '#ffffff',
              fontSize: '13px',
              fontWeight: 600,
              letterSpacing: '0.01em',
            }}
          >
            You are offline
          </span>
        )}
      </div>
    </>
  );
};

export default OfflineIndicator;
